import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Userback from '@userback/widget';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // Store environment globally for access from services
    (window as any).__env__ = environment.nodeEnv;

    // Initialize Userback after app is bootstrapped
    if (environment.userbackToken) {
      console.debug('Initializing Userback with token:', environment.userbackToken);
      console.debug('Environment:', environment.nodeEnv);

      // Detect user type from URL parameter
      const urlParams = new URLSearchParams(window.location.search);
      const isInternal = urlParams.get('internal') === 'true';
      const userType = isInternal ? 'internal' : 'client';

      // Detect service type from URL path
      const pathname = window.location.pathname;
      let serviceType = 'unknown';
      if (pathname.includes('/reports/corey')) {
        serviceType = 'corey-report';
      } else if (pathname.includes('/documents/order-confirmation')) {
        serviceType = 'order-confirmation';
      }

      console.debug('User type detected:', userType);
      console.debug('Service type detected:', serviceType);

      Userback(environment.userbackToken, {
        // Custom data
        custom_data: {
          application: 'open-viewer',
          environment: environment.nodeEnv,
          user_type: userType,
          service_type: serviceType,
          tags: [`user:${userType}`, `service:${serviceType}`, `env:${environment.nodeEnv}`],
        },

        // Don't auto-hide the widget
        autohide: false,
        // Enable session recording by default
        // Note: Session recording configuration may be done through Userback dashboard
      } as any) // Cast to any to support additional options like session recording
        .then((userbackInstance: any) => {
          // Store the instance globally
          (window as any).Userback = userbackInstance;
          console.info('Userback successfully initialized');
          console.info('Session tagged as:', userType);

          // Start session replay with tags
          if (typeof userbackInstance.startSessionReplay === 'function') {
            const tags = [
              `user:${userType}`,
              `service:${serviceType}`,
              `env:${environment.nodeEnv}`,
            ];
            console.debug('Starting session replay with tags:', tags);
            userbackInstance.startSessionReplay({
              tags: tags,
            });
          } else {
            console.warn('startSessionReplay method not available');
          }
        })
        .catch(error => {
          console.error('Failed to initialize Userback:', error);
        });
    }
  })
  .catch(err => console.error(err));
